import * as React from 'react'
import styled, { css } from 'styled-components'
import ReactModal from 'react-modal'

import Icon from '../../ui/Icon/Icon'

import media from '../../../services/generateMediaQueries'

import ZingBrand from '../../../assets/img/brand.webp'
import LoungePassBackground from '../../../assets/img/lounge-pass/lounge-pass-background.svg'

import downloadAppLink from '../../../services/redirection/downloadAppLink'
import SidebarPeople from '../../../assets/img/sidebar-people.svg'
import AppStore from '../../../assets/img/app-download/app-store.png'
import PlayStore from '../../../assets/img/app-download/play-store.png'
import { APP_NAME } from '../../../static/constants'

const StoreBubbles = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding: 2rem 0;
`

const Store = styled.img`
  cursor: pointer;
  height: 39px;

  &:first-child {
    margin-right: 1.1875rem;
  }
`

const StyledReactModal = styled(ReactModal)`
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  transition: all var(--animation-duration) var(--animation-easing);

  &.ReactModal__Content {
    &--after-open {
      opacity: 1;
      transition: all var(--animation-duration) var(--animation-easing);
    }

    &--before-close {
      opacity: 0;
      transition: all calc(var(--animation-duration) / 2)
        var(--animation-easing);
    }
  }

  ${media.lessThan('small')`
    top: 0;
    right: 0;
    height: 100% !important;
    border-radius: 0;
    max-width: unset;
    max-height: unset;
  `}
`

const ModalContentWrapper = styled.div`
  overflow: auto;
  max-height: 100vh;
  width: 100%;
`

const DefaultCloseButton = styled.button`
  position: absolute;
  color: #ffffff;
  border: 0;
  top: 15px;
  right: 15px;
  font-size: 25px;
  cursor: pointer;
  background: rgba(255, 255, 255, 0.5);
  width: 32px;
  height: 32px;
  padding: 4px;
  border-radius: 100%;
  outline: none;

  ${props =>
    props.zIndex &&
    css`
      z-index: ${props.zIndex + 1};
    `}

  > svg {
    vertical-align: baseline;
  }
`

const ModalContent = styled.div`
  position: relative;
  margin: 3rem auto;
  width: 325px;
  min-height: 400px;
  border-radius: 8px;
  overflow: hidden;

  ${media.lessThan('small')`
    margin: 0;
    height: 100%;
    width: 100%;
    border-radius: 0;
  `}
`

const Content = styled.div`
  background: #ffffff;
`

const Header = styled.div`
  padding-top: 3rem;
  margin-bottom: 30px;
  background-image: url('${LoungePassBackground}');
  background-size: cover;
  background-position: bottom;
`

const HeaderIcon = styled.img.attrs({ src: ZingBrand })`
  display: block;
  width: 115px;
  margin: 0 auto;
  margin-bottom: 1rem;
  position: relative;
  z-index: 1;
`

const Title = styled.h3`
  color: white;
  font-size: 1.125rem;
  font-weight: var(--font-weight-bold);
  line-height: 1.5625rem;
  text-align: center;
  margin: 0 1rem;
  margin-bottom: 1rem;
  position: relative;
  z-index: 1;
`

const StyledLoungeImage = styled.img`
  display: block;
  margin: -50px auto 0;
  position: relative;
  bottom: -25px;
  width: 100%;
`

const overlay = {
  zIndex: 10000,
  background: 'rgba(0, 0, 0, 0.8)',
}

const content = {}

function GenericDownloadAppModal(props) {
  const {
    handleClose,
    show,
    loading,
    onClose,
    children,
    CloseButton,
    zIndex,
    unlimited,
    shouldCloseOnOverlayClick = true,
    ...restProps
  } = props

  // const [dateNow, setDateNow] = React.useState(new Date())

  // const tick = () => {
  //   setDateNow(new Date())
  // }

  // React.useEffect(() => {
  //   const timerID = setInterval(() => tick(), 1000)

  //   return () => {
  //     clearInterval(timerID)
  //   }
  // })

  return (
    <StyledReactModal
      isOpen={show}
      style={{
        overlay: {
          ...overlay,
          ...(zIndex ? { zIndex } : {}),
        },
        content,
      }}
      onRequestClose={onClose}
      closeTimeoutMS={150}
      shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
      bodyOpenClassName="sticky-modal-open"
      htmlOpenClassName="sticky-modal-open"
      {...restProps}
    >
      <ModalContentWrapper>
        <ModalContent>
          <DefaultCloseButton zIndex={zIndex} onClick={onClose}>
            <Icon name="x" />
          </DefaultCloseButton>
          <Content>
            <Header>
              <HeaderIcon />
              <Title>
                Download {APP_NAME} mobile app for free and get exclusive access
                to this feature!
              </Title>
              <StyledLoungeImage src={SidebarPeople} />
            </Header>
            <StoreBubbles>
              <Store src={AppStore} onClick={downloadAppLink('iOS')} alt="" />
              <Store
                src={PlayStore}
                onClick={downloadAppLink('Android')}
                alt=""
              />
            </StoreBubbles>
          </Content>
        </ModalContent>
      </ModalContentWrapper>
    </StyledReactModal>
  )
}

GenericDownloadAppModal.defaultProps = {}

GenericDownloadAppModal.propTypes = {}

export default GenericDownloadAppModal
